import React, { useEffect, useState } from 'react';
import ReviewersGrid from "@/components/reviewer/ReviewersGrid";
import {
  Heading,
  Flex,
  Box,
  Button
} from "@chakra-ui/react";
import NextLink from "next/link";
import { getUsers, manageSessions } from 'store/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import { updateSessionStatusByFirebase } from '@/lib/db';
import firebase from "firebase";
export const TopFeaturedMentor = () => {
  const dispatch=useDispatch();
  const {user,users}=useSelector(state=>state.auth);
  const [mentors, setMentors] = useState([]);
  const firestore = firebase.firestore();
  const db = firestore;
  useEffect(() => {
    const unsubscribe = db.collection("listProfileUpdate").onSnapshot(
      (snapshot) => {
        const updatedData = snapshot.docs.map((doc) => ({
          ...doc.data(),
        }));
        if(updatedData[0]?.update){
          dispatch(getUsers({page:1,limit:10,role:'mentor',status:'verified'}));
          dispatch(manageSessions({method:'get'}));
        }
        updateSessionStatusByFirebase(false,false);
      },
      (error) => {
        console.error("Error fetching sessions:", error);
      }
    );

    return () => unsubscribe();
  }, []);
  useEffect(()=>{
    dispatch(getUsers({page:1,limit:10,role:'mentor',status:'verified'}));
    dispatch(manageSessions({method:'get'}));
  }, [])
  useEffect(()=>{
    const filteredMentors = users?.filter((i, _)=>i?.role !== "owner" && (i._id!==user?._id) && i?.is_activated && i?.is_applied && i?.is_approved &&  i?.services?.length > 0);
    filteredMentors && setMentors([...filteredMentors]);
  }, [users]);
  return (mentors?.length>0 && <Box w={["100%", "100%"]} className="mentor-cards-wrap mb-80">
      <Box className="container mx-auto">
        <h2 className="heading-color">Top Featured Mentor</h2>
        <Box w={["100%", "100%", "100%", "100%"]}>
          <Flex className="review-card-wrapper mt-25">
            <ReviewersGrid reviewers={mentors} />
          </Flex>
          <NextLink href="/reviewers/listing" className="flex">
            <Button variant="solid" className="btn dark-blue-btn mt-25 mx-auto">
              View All
            </Button>
          </NextLink>
        </Box>
      </Box>
    </Box>
  );
};
